var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.showFileRecord
        ? _c(
            "button",
            {
              staticClass: "btn btn-outline-info btn-xs",
              on: {
                click: function ($event) {
                  _vm.showFileRecord = !_vm.showFileRecord
                },
              },
            },
            [
              _c("i", { staticClass: "icon-fa icon-fa-volume-up" }),
              _vm._v(" Прослушать запись\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFileRecord
        ? [
            _vm.record
              ? _c("audio", { attrs: { controls: "" } }, [
                  _c("source", {
                    attrs: {
                      src: `https://admin.rancond.info/api/noa/mangoRecord/${_vm.record.id}`,
                      type: "audio/mpeg",
                    },
                  }),
                  _vm._v(
                    "\n      Your browser does not support the audio tag.\n    "
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }